// src/components/MetaPixel.jsx

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getClientConfig } from "../config/clientConfig";

function initPixel(pixelId) {
    if (window.fbq) return;

    // ✅ Fixed: written as a proper named function instead of IIFE
    const fbq = function () {
        if (fbq.callMethod) {
            fbq.callMethod.apply(fbq, arguments);
        } else {
            fbq.queue.push(arguments);
        }
    };

    window.fbq = fbq;
    window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
}

export default function MetaPixel() {
    const location = useLocation();
    const config = getClientConfig();

    useEffect(() => {
        if (config?.pixelId) {
            initPixel(config.pixelId);
        }
    }, []);

    useEffect(() => {
        if (window.fbq && config?.pixelId) {
            window.fbq("track", "PageView");
        }
    }, [location.pathname]);

    if (!config?.pixelId) return null;

    return (
        <noscript>
            <img
                height="1"
                width="1"
                style={{ display: "none" }}
                src={`https://www.facebook.com/tr?id=${config.pixelId}&ev=PageView&noscript=1`}
                alt=""
            />
        </noscript>
    );
}